







import Vue from 'vue';
import { Component } from "vue-property-decorator";

@Component({})
export default class GoogleRecaptchaV2 extends Vue {
  rendered = false;
  constructor() { super(); }

  mounted() {
    window.captchaCallback = () => {
      if (this.rendered) return;
      grecaptcha.render("g-recaptcha", {
        sitekey: process.env.googleRecaptchaSiteKey,
        theme: "light",
        callback: (key: string) => (this.$emit("onVerify", key))
      });
      this.rendered = true;
    };
  }
};
